function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from "@react-google-maps/api";
import { currencyToIndianRsWord } from "../../../../utils/helpers";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var SingleGMaps = function SingleGMaps(_ref) {
  var location = _ref.location,
    viewport = _ref.viewport,
    setViewport = _ref.setViewport,
    projectName = _ref.projectName,
    projectPrice = _ref.projectPrice,
    projectCity = _ref.projectCity,
    config = _ref.config;
  var _useJsApiLoader = useJsApiLoader({
      id: "google-map-script",
      googleMapsApiKey: "AIzaSyD8g5LLt4YxRR363AOmHEZhGHaUctJIz4Q"
    }),
    isLoaded = _useJsApiLoader.isLoaded;
  var _useState = useState(_objectSpread(_objectSpread({}, viewport), {}, {
      center: {
        lat: 22.43,
        lng: 80.84
      },
      zoom: 14
    })),
    _useState2 = _slicedToArray(_useState, 2),
    viewP = _useState2[0],
    setViewP = _useState2[1];
  useEffect(function () {
    if (location && location.latitude && location.longitude) {
      setViewP(_objectSpread(_objectSpread({}, viewP), {}, {
        center: {
          lat: parseFloat(location.latitude.trim()).toFixed(5),
          lng: parseFloat(location.longitude.trim()).toFixed(5)
        }
      }));
    }
  }, [location]);
  useEffect(function () {
    if (setViewport) {
      setViewport(viewP);
    }
  }, [viewP, setViewport]);
  var currencyFormating = function currencyFormating(price) {
    if (price >= 10000000) return currencyToIndianRsWord.format(price).slice(0, -2).concat(" Cr*");
    return currencyToIndianRsWord.format(price).slice(0, -1).concat(" L");
  };
  return isLoaded ? /*#__PURE__*/_jsx(GoogleMap, {
    center: {
      lat: parseFloat(viewP.center.lat),
      lng: parseFloat(viewP.center.lng)
    },
    zoom: viewP.zoom,
    mapContainerStyle: {
      width: "100%",
      height: "100%"
    },
    children: location && viewP.center.lat && viewP.center.lng && /*#__PURE__*/_jsx(Marker, {
      position: {
        lat: parseFloat(viewP.center.lat),
        lng: parseFloat(viewP.center.lng)
      },
      children: /*#__PURE__*/_jsx(InfoWindow, {
        position: {
          lat: parseFloat(viewP.center.lat),
          lng: parseFloat(viewP.center.lng)
        },
        children: /*#__PURE__*/_jsxs("div", {
          className: "select-none cursor-pointer",
          children: [/*#__PURE__*/_jsxs("h2", {
            className: "".concat(config.fontBody, " uppercase font-semibold md:text-[11px]"),
            children: [projectName, " ", "(".concat(projectCity, ")")]
          }), /*#__PURE__*/_jsxs("p", {
            className: "".concat(config.fontTitle, " pt-1 text-center font-semibold md:text-[12px]"),
            children: ["STARTING: ", currencyFormating(projectPrice)]
          })]
        })
      })
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};
export default SingleGMaps;